<app-card-relatorio-laudo [titulo]="template.label" [status]="template.status">
    <div *ngFor="let e of display" class="p-1">
      <div [ngClass]="{'hide-print': e?.imprimir === false}">
        <div *ngIf="e.type!='MEDIA'" class="row mb-2 mb-md-0">
            <div class="col-12 col-md-6">
              <span class="text-secondary">{{e.label}}: </span> <span>{{e.value}}</span>
            </div>
              <div  class="col-6 col-md-3">
                  <ng-container *ngIf="e.dataFabricacao">
                      <span class="text-secondary">Fabricação:</span> <span>{{e.dataFabricacao.value}}</span>
                  </ng-container>
              </div>
              <div class="d-flex align-items-center justify-content-end col-6 col-md-3">
                  <span> Nº CHASSI GRAVADO: </span><i class="mdi f-22 ml-2"
                      [ngClass]="{
                          'mdi-check': e.value.toLowerCase()=='original' || e.value.toLowerCase()=='não aplicável' || e.value.toLowerCase()=='não original',
                          'mdi-close': e.value.toLowerCase()!='original' && e.value.toLowerCase()!='não aplicável' && e.value.toLowerCase()!='não original'
                  }"></i>

                  <!-- Caso exista value, todos são exibidos como checkado a pedido do Cadu -->
                  <!--<span> Nº CHASSI GRAVADO: </span><i class="mdi f-22 ml-2" [ngClass]="{'mdi-check': e.value}"></i>-->
              </div>
          </div>
        </div>
    </div>
    <app-lista-img [elements]="template.elements"></app-lista-img>
</app-card-relatorio-laudo>
